module.exports = __webpack_public_path__ + "img/top-girl-11.36549dd1.png";